import apiRequest from './apiRequest';
import { sanitizePromptAsFilename } from '../utils';

export type JobDownloadResponse = {
  downloadURL: string;
};

/** Browser download filename for a full-job zip or a single-body slice zip. */
export function jobZipDownloadFilename(
  displayName: string,
  jobID: string,
  bodyIndex?: number,
): string {
  const slug =
    sanitizePromptAsFilename(displayName.trim() || jobID, 80) ||
    jobID.replace(/[^\w.-]+/g, '_').slice(0, 80);
  const base = slug.endsWith('.zip') ? slug.slice(0, -4) : slug;
  if (bodyIndex === undefined) {
    return `${base}.zip`;
  }
  return `${base}_${String(bodyIndex).padStart(2, '0')}_body.zip`;
}

export default async function getJobDownload(
  batchID: string,
  jobID: string,
  apiKey: string,
  options?: { bodyIndex?: number },
): Promise<JobDownloadResponse> {
  const q =
    options?.bodyIndex !== undefined
      ? `?bodyIndex=${encodeURIComponent(String(options.bodyIndex))}`
      : '';
  const { data, error } = await apiRequest<JobDownloadResponse>(
    'external-mogen',
    `/exports/batches/${batchID}/jobs/${jobID}${q}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
  if (error) throw error;
  return data!;
}
